<template>
  <div class="m_tooltip">
    <div
      ref="flag"
      class="m_tooltip_flag"
      @click.stop="m_tooltip_show = !m_tooltip_show"
    >
      <slot />
      <div
        v-if="m_tooltip_show"
        :style="contentStyle"
        class="m_tooltip_content"
      >
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
import { maskClick } from '../pages/mixin/maskClick';

export default {
  mixins: [maskClick('m_tooltip_show')],
  props: {
    arrow: {
      type: String,
      default: 'right',
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      m_tooltip_show: false,
      w: 0,
      h: 0,
    };
  },
  computed: {
    contentStyle() {
      /**
       * left: l::(-w-10) t::(50%)
       * right: l::(w+10) t::(50%)
       * top: t::(-h-10) l::(50%)
       * bottom: t::(h+10) l::(50%)
       */
      const obj = {
        left: {
          left: `${-this.w - 10}px`,
          top: '50%',
          transform: 'translateY(-50%)',
        },
        right: {
          left: `${this.w + 10}px`,
          top: '50%',
          transform: 'translateY(-50%)',
        },
        top: {
          top: `${-this.h - 10}px`,
          left: '50%',
          transform: 'translateX(-50%)',
        },
        bottom: {
          top: `${this.h + 10}px`,
          left: '50%',
          transform: 'translateX(-50%)',
        },
      };
      return {
        ...obj[this.arrow],
      };
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.w = this.$refs.flag.clientWidth;
      this.h = this.$refs.flag.clientHeight;
    });
  },
};
</script>

<style scoped lang="scss">
.m_tooltip {
  display: inline-block;
  &_flag {
    position: relative;
    display: inline-block;
  }
  &_content {
    position: absolute;
    text-align: left;
    left: 32px;
    top: -16px;
    padding: 12px;
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.72);
    font-size: 12px;
    color: #fff;
    line-height: 16px;
    z-index: 10;
    word-break: break-word;
    width: 200px;
    &::before {
      content: '';
      display: block;
      position: absolute;
      left: -20px;
      top: 50%;
      font-size: 0;
      transform: translateY(-50%);
      border: 10px solid rgba(0, 0, 0, 0.72);
      border-left: 10px solid transparent;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
    }
  }
}
</style>
